<div class="chart-wrapper">
  <div echarts [options]="adaptedOptions()" [merge]="adaptedOptions()" [initOpts]="initOpts" class="chart"></div>
</div>
